import { ImpersonatorUserDetails } from "@cofano/coastguard2-frontend-client";
import { Box, Tooltip } from "@mui/material";
import { intl } from "LocaleWrapper";
import { TooltipProps } from "@mui/material/Tooltip/Tooltip";
import CoastguardUserDetails from "components/layout/coastguard/CoastguardUserDetails";

const CoastguardSessionImpersonatorTooltip = ({
	impersonator,
	children,
	...rest
}: {
	impersonator: Pick<ImpersonatorUserDetails, "displayName" | "username" | "tenantName"> | null;
} & Omit<TooltipProps, "title">) => (
	<Tooltip
		placement="right"
		{...rest}
		title={impersonator != null ? (
			<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
				<Box sx={{ fontSize: 13, color: (theme) => theme.palette.common.white }}>
					{intl.formatMessage({ id: "COASTGUARD_IMPERSONATED_BY" })}:
				</Box>

				<CoastguardUserDetails userDetails={impersonator} />
			</Box>
		) :	undefined}
	>
		{children}
	</Tooltip>
);

export default CoastguardSessionImpersonatorTooltip;
